import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRelations",
  "use": "outRelations-usage",
  "viewBox": "0 0 19.64 18",
  "content": "<symbol viewBox=\"0 0 19.64 18\" id=\"outRelations\"><title>外部关系</title><path d=\"M13.5,11.5a.44.44,0,0,0-.55,0,4.36,4.36,0,0,1-5.73,0,.42.42,0,0,0-.53,0,4.37,4.37,0,0,1-4.29.83c-.07,0-.17,0-.17-.07v4.91a1.85,1.85,0,0,0,2,1.85H15.94A1.91,1.91,0,0,0,18,17.15V12.24a4.36,4.36,0,0,1-4.53-.74ZM7.24,17.93a.44.44,0,0,1-.88,0v-5a.44.44,0,0,1,.88,0Z\" transform=\"translate(-0.27 -1)\" /><path d=\"M19.79,7.35l0-.12L17.16,1.94A1.69,1.69,0,0,0,15.65,1H4.47A1.67,1.67,0,0,0,3,1.94L.42,7.24l0,.11a3,3,0,0,0-.11.83,3.55,3.55,0,0,0,6.36,2.17.42.42,0,0,1,.65,0,3.54,3.54,0,0,0,5.62,0,.41.41,0,0,1,.65,0A3.55,3.55,0,0,0,17,11.68a3.75,3.75,0,0,0,2.87-3.63A4.8,4.8,0,0,0,19.79,7.35Z\" transform=\"translate(-0.27 -1)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRelations.svg
// module id = mVBQ
// module chunks = 264